"use client"

import { useState } from "react";
import BasicText from "../../BasicText";
import Title from "../../Title";
import MissionFrame from "../../svg/MissionFrame";
import backgroundtxture from '@/assets/images/ASCII/Frame 1473.png';
import Image from "../../Image";

function WhyLuminodeFrame({ subtitle = '// 01', title = 'Experience', children, text='Lorem ipsum dolor sit amet, consectetur\nadipiscing elit. Nunc vulputate libero et\nvelit interdum, ac aliquet odio mattis.' }: any) {
  const [hovered, setHovered] = useState(false);
  let textJSX = [];
  for (let line of text.split('\n')) {
    textJSX.push(<div key={`${line}`}>{line}</div>)
  }

  return (
    <div
      className="grow xl:grow-0 lg:w-[33%] h-full relative transition-all ease-in-out duration-[1000]"
      onMouseEnter={() => { setHovered(true); }}
      onMouseLeave={() => { setHovered(false); }}
    >
      <div className="flex flex-col items-start justify-end p-[35px] h-full">
        <BasicText className='text-[#9494A8] opacity-50 text-[13px] pb-[10px]'>
          {subtitle}
        </BasicText>
        <Title>
          <div className="text-[24px] font-light pb-[15px] tracking-normal">
            {title}
          </div>
        </Title>
        <BasicText className={`text-[#9494A8] opacity-50 text-[13px] overflow-clip ${hovered ? 'max-h-[1000px]' : 'max-h-0'}`}>
          {textJSX}
        </BasicText>
      </div>
      <div className="absolute top-0 w-full h-full">
        <div className="relative z-20 w-full h-full">
          <MissionFrame />
        </div>
      </div>
      <div className="absolute top-[-100px] right-0 z-30">
        {children}
      </div>
      <div className={`absolute top-0 ${hovered ? '' : 'hidden'} h-full w-full blur-sm`}>
        <Image alt='' src={backgroundtxture} fill />
      </div>
    </div>
  );
}

export default WhyLuminodeFrame;